import { apiPath, OrganizationSecuritySchema, RecoveryCodesSchema, TotpSetupSchema, TwoFactorStatusSchema } from '@codot/contracts';
import { request } from './http';

/** Two-factor sign-in: your own settings, and the organization's requirement. */
export const twoFactorApi = {
  status: () => request('GET', apiPath('me2fa'), TwoFactorStatusSchema),
  setup: () => request('POST', apiPath('me2faSetup'), TotpSetupSchema),
  enable: (code: string) => request('POST', apiPath('me2faEnable'), RecoveryCodesSchema, { code }),
  disable: (password: string, code: string) => request('POST', apiPath('me2faDisable'), null, { password, code }),
  newRecoveryCodes: (code: string) => request('POST', apiPath('me2faRecoveryCodes'), RecoveryCodesSchema, { code }),
  orgSecurity: () => request('GET', apiPath('organizationSecurity'), OrganizationSecuritySchema),
  setOrgSecurity: (require2fa: boolean) => request('PUT', apiPath('organizationSecurity'), OrganizationSecuritySchema, { require2fa }),
};
